import React from "react";
import { Pivot, PivotItem, Label } from "@fluentui/react";
import "./Tabs.scss";

const Tabs = (props: any) => {
  return (
    <div className="pivot">
      <Pivot
        styles={props.tabStyles}
        linkFormat={props.linkFormat || "tabs"}
        selectedKey={props.selectedKey}
        onLinkClick={props.handleLinkClick}
      >
        {props.tabItems.map((item: any, index: any) => {
          return (
            <PivotItem
              headerText={item.headerText}
              key={index}
              itemIcon={item.itemIcon}
              itemKey={item.itemKey}
            >
              <Label styles={props?.labelStyles} htmlFor={""} data-attribute="index_Default_Label_8">
                {item.content}
              </Label>
            </PivotItem>
          );
        })}
      </Pivot>
    </div>
  );
};

export default Tabs;
